/**
 *Angular module*/
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MultiSelectService} from '../../services/multi-select.service';

/**
 *Interfaces*/
interface Item {
    id: number;
    value: string;
    parent_id: number;
    disabled?: boolean;
}

interface Group {
    id: number;
    name: string;
    variant: Item[];
    disabled?: boolean;
}

@Component({
    selector: 'app-mat-multi-select',
    templateUrl: './mat-multi-select.component.html'
})

export class MatMultiSelectComponent implements OnInit {
    control: FormControl;
    @Output() onTaskChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() groups: Group[];
    @Input() limit = 1;
    @Input() index = 0;
    @Input() selected: any;
    @Input() allowService = false;
    @Input() disableOption = false;
    finalVariants = [];
    limitReached = [];

    constructor(public multiSelectService: MultiSelectService) {
    }

    ngOnInit(): void {
        this.control = new FormControl();
        if (this.allowService) {
            this.multiSelectService.getVariants().then((variants: Group[]) => {
                this.groups = variants;
                this.groups.forEach((item: Group) =>
                    item.variant = item.variant.map((variantItem: Item) => {
                        variantItem.disabled = false;
                        return variantItem;
                    })
                );
                this.control.setValue(this.selected);
                this.update(this.selected);
            });
        } else {
            this.control.setValue(this.selected);
            this.update(this.selected);
        }
    }

    compareObjects(o1: any, o2: any): any {
        return o1.id == o2.id;
    }

    update(selectedValue: any): void {
        this.finalVariants = [];
        this.limitReached = [];
        selectedValue.forEach((variants: any, variantKey: number) => {
            (this.finalVariants[variants['parent_id']] == undefined
                    ? this.finalVariants[variants['parent_id']] = {parent_id: variants['parent_id'], value: [variants['id']]}
                    : this.finalVariants[variants['parent_id']]['value'].length >= this.limit
                        ? this.control.value.splice(variantKey) ? this.limitReached.push(variants['parent_id']) : false
                        : this.finalVariants[variants['parent_id']]['value'].push(variants['id'])
            );
            this.finalVariants[variants['parent_id']]['value'].length >= this.limit ? this.limitReached.push(variants['parent_id']) : false;
        });
        this.limitReached = unique(this.limitReached);
        this.control.setValue(this.control.value);
        this.finalVariants = this.finalVariants.filter((variantDetail: any) => variantDetail != null);

        /**
         * To disable options after limit has been reached
         * */
        if (this.disableOption) {
            this.groups.forEach((item: Group) =>
                item.variant = item.variant.map((variantItem: Item) => {
                    variantItem.disabled = false;
                    return variantItem;
                })
            );

            this.finalVariants.forEach((finalVariant: any) =>
                this.groups.forEach((item: Group) =>
                    item.id == finalVariant['parent_id']
                        ? this.limitReached.forEach((limitReached: any) => {
                            finalVariant.value.forEach((variantToFind: any) => {
                                item.variant = item.variant.map((variantItem: any) => {
                                    variantItem.id == variantToFind
                                        ? variantItem.disabled = false
                                        : item.id == limitReached ? finalVariant.value.find(x => x == variantItem.id) == undefined ? variantItem.disabled = true : false
                                        : false;
                                    return variantItem;
                                });
                            });
                        }) : false
                )
            );
        }

        this.onTaskChange.emit([this.index, this.control]);

        function unique(a: any) {
            return a.sort().filter(function (item: any, pos: number, ary: Array<any>) {
                return !pos || item != ary[pos - 1];
            });
        }
    }
}
